import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, FormControlLabel, Grid, MenuItem, Switch, } from '@mui/material';
import { Form, Formik } from 'formik';
import { forwardRef, useCallback, useContext, useImperativeHandle, useRef, useState, } from 'react';
import { countries, SelectField } from '../../UserDataManagement';
import { BankHolidaysDeducting, CountryCode, RegionCode } from '../../UserDataManagement';
import { introEntitlementExceptionSchemaFunc, } from '../../yup-schemas';
import { EntitlementExceptionsActionKind, initialEntitlementExceptionsState, IntroSetupContext, } from '../reducer';
// eslint-disable-next-line react/display-name
export const EntitlementExceptionsPage = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleSubmit() {
            formRef.current.handleSubmit();
        },
        getIsValid() {
            return formRef.current.isValid;
        },
        handleSkip() {
            entitlementExceptionsDispatch({
                type: EntitlementExceptionsActionKind.ModifyEntitlementExceptions,
                payload: initialEntitlementExceptionsState,
            });
        },
    }));
    const { entitlementExceptionsState, entitlementExceptionsDispatch } = useContext(IntroSetupContext);
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    const formRef = useRef();
    const [country, setCountry] = useState();
    if (entitlementExceptionsState.countryCode) {
        const countryOriginal = countries.find((em) => em.Code === entitlementExceptionsState.countryCode);
        if (countryOriginal && country === undefined) {
            setCountry(countryOriginal);
        }
    }
    const handleSubmit = useCallback((values) => {
        entitlementExceptionsDispatch({
            type: EntitlementExceptionsActionKind.ModifyEntitlementExceptions,
            payload: {
                regionCode: values.regionCode,
                countryCode: values.countryCode,
                bankHolidaysDeducting: values.bankHolidaysDeducting,
            },
        });
    }, [entitlementExceptionsDispatch]);
    const handleCountryChange = useCallback((event) => {
        const code = event.target.value;
        const newCountry = countries.find((em) => em.Code === code);
        if (newCountry) {
            setCountry(newCountry);
            formRef.current.setFieldValue(CountryCode, code);
            formRef.current.setFieldValue(RegionCode, newCountry.Regions[0]);
        }
        if (formRef.current) {
            formRef.current.handleChange(event);
            if (newCountry?.Regions.length === 0) {
                formRef.current.setFieldValue(RegionCode, '');
            }
        }
    }, []);
    const handleRegionChange = useCallback((event) => {
        const code = event.target.value;
        formRef.current.setFieldValue(RegionCode, code);
    }, []);
    return (_jsx(Box, { children: _jsx(Grid, { container: true, justifyContent: "center", sx: { width: '100%' }, children: _jsx(Formik, { initialValues: {
                    regionCode: entitlementExceptionsState.regionCode,
                    countryCode: entitlementExceptionsState.countryCode,
                    bankHolidaysDeducting: entitlementExceptionsState.bankHolidaysDeducting,
                }, onSubmit: handleSubmit, validateOnMount: true, innerRef: formRef, validationSchema: introEntitlementExceptionSchemaFunc, children: ({ values, handleChange, errors }) => (_jsx(Form, { children: _jsxs(Grid, { container: true, sx: { width: '100%', marginTop: '1em' }, rowSpacing: 1, justifyContent: "center", children: [_jsx(Grid, { item: true, xs: 12, container: true, alignItems: "center", justifyItems: "center", sx: {
                                    paddingBottom: '7px',
                                    marginBottom: values.bankHolidaysDeducting ? '0em' : '1em',
                                }, children: _jsx(FormControlLabel, { label: 'Do bank holidays deduct from your entitlement?', name: BankHolidaysDeducting, sx: { marginRight: '5px' }, control: _jsx(Switch, { color: 'primary', name: "bankHolidaysDeducting", value: values.bankHolidaysDeducting, checked: values.bankHolidaysDeducting, onChange: handleChange, inputProps: { 'aria-label': 'primary checkbox' } }) }) }), !values.bankHolidaysDeducting && (_jsxs(Grid, { item: true, xs: 12, sx: { marginBottom: '2em' }, children: [_jsx(FormControl, { sx: { width: '100%', marginBottom: '2rem' }, children: _jsx(SelectField, { name: CountryCode, errorMessage: errors.countryCode, label: "Bank holiday country", value: values.countryCode, onChangeOverride: handleCountryChange, sx: { width: '100%' }, children: countries.map((em, index) => (_jsx(MenuItem, { value: em.Code, children: em.Name }, index))) }) }), country && country.Regions.length > 0 && (_jsx(FormControl, { sx: { width: '100%' }, children: _jsx(SelectField, { name: RegionCode, errorMessage: errors.regionCode, label: "Bank holiday region", onChangeOverride: handleRegionChange, required: true, value: values.regionCode, sx: { width: '100%' }, children: country.Regions.map((em, index) => (_jsx(MenuItem, { value: em, children: em }, index))) }) }))] })), values.bankHolidaysDeducting && (_jsx(Box, { sx: { marginBottom: '2em' }, children: _jsx("p", { children: _jsx("small", { children: "To add bank holidays, finish setting up then add them in your settings page." }) }) })), _jsx(Grid, { item: true, xs: 12, children: _jsx(Box, { sx: { position: 'absolute', bottom: '2rem', marginRight: '1em' }, children: _jsx("p", { children: _jsx("small", { children: "You can go back at any time to change information, just click the back button." }) }) }) })] }) })) }) }) }));
});
